import React from 'react';
import { Avatar, Box } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const HeaderCard = ({ item, setActiveMenu, activeMenu }) => {
    const { section_name, section_image } = item
    return (
        <Box>
            <div onClick={() => setActiveMenu(section_name)}>
                <Box sx={{
                    position: 'relative',
                    height: 48,
                    width: 48,
                    margin: "auto",
                    cursor: 'pointer'
                }}>
                    <Avatar
                        src={section_image}
                        alt={section_name}
                        sx={{ height: 48, width: 48, margin: "auto" }}
                    />

                    {activeMenu === section_name &&
                        <div
                            className='absolute top-0 left-0 w-full h-full border-2 bg-black bg-opacity-40 border-black flex justify-center items-center rounded-full'
                        >
                            <CheckCircleIcon sx={{ color: "black" }} />
                        </div>}
                </Box>
            </div>
            <h2
                className='text-sm text-center font-semibold truncate'
            >
                {section_name?.charAt(0)?.toUpperCase() + section_name?.slice(1).toLowerCase()}
            </h2>
        </Box>
    )
}

export default HeaderCard